import EmailUpdateForm from '@/components/user/settings/security/email-update-form';
import PasswordUpdateForm from '@/components/user/settings/security/password-update-form';
import { useAuth } from '@/contexts/auth-context';
import { useTranslation } from 'react-i18next';
import AccountSettingsPageShell from './AccountSettingsPageShell';
import SettingsSection from '../components/SettingsSection';

const AccountSecuritySettingsPage = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const hasPassword = user?.hasPassword ?? true;

  return (
    <AccountSettingsPageShell titleKey="settings.accountNav.security">
      <SettingsSection
        title={t('settings.emailUpdate.title')}
        description={t('settings.emailUpdate.description')}
      >
        <EmailUpdateForm showActions />
      </SettingsSection>

      <SettingsSection
        title={
          hasPassword ? t('settings.passwordUpdate.title') : t('settings.passwordUpdate.addTitle')
        }
        description={t('settings.passwordUpdate.description')}
        isLast
      >
        <PasswordUpdateForm showActions />
      </SettingsSection>
    </AccountSettingsPageShell>
  );
};

export default AccountSecuritySettingsPage;
